/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Check_Env_CommittedInputs */

const en_rd_check_env_committed = /** @type {(inputs: Rd_Check_Env_CommittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No .env committed`)
};

const id_rd_check_env_committed = /** @type {(inputs: Rd_Check_Env_CommittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada .env yang ter-commit`)
};

/**
* | output |
* | --- |
* | "No .env committed" |
*
* @param {Rd_Check_Env_CommittedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_check_env_committed = /** @type {((inputs?: Rd_Check_Env_CommittedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Check_Env_CommittedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_check_env_committed(inputs)
	return en_rd_check_env_committed(inputs)
});